/* import __COLOCATED_TEMPLATE__ from './source.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import type ContentImportRun from 'embercom/models/content-service/content-import-run';
import type ContentImportSource from 'embercom/models/content-service/content-import-source';

interface Signature {
  Args: {
    contentImportSource: ContentImportSource;
    contentImportRun: ContentImportRun;
  };
  Element: HTMLElement;
}

export default class StandaloneContentImportSource extends Component<Signature> {
  get latestRun() {
    return this.args.contentImportRun;
  }

  get statusClasses() {
    if (this.latestRun.isFailed) {
      return 'bg-error-fill text-on-error';
    }

    if (this.latestRun.isCompleted) {
      return 'bg-success-fill text-on-success';
    }

    return 'bg-neutral-container text-default';
  }

  get statusIcon(): InterfaceIconName {
    if (this.latestRun.isFailed) {
      return 'alert';
    }

    if (this.latestRun.isCompleted) {
      return 'check';
    }

    return 'sync';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Content::Source': typeof StandaloneContentImportSource;
    'standalone/setup/content/source': typeof StandaloneContentImportSource;
  }
}
